// extracted by mini-css-extract-plugin
export var blink = "styles-module--blink--WpS3d";
export var card_content = "styles-module--card_content--vfE2I";
export var m_pre_footer = "styles-module--m_pre_footer--wWdU3";
export var title = "styles-module--title--Kwc3k";